import * as types from '../../address/store/address.actionType';
import * as commonActionType from '@common/store/common/common.actionsType';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  Cep: undefined,
  Uf: undefined,
  Cidade: undefined,
  Logradouro: undefined,
  Tipo: undefined,
  Bairro: undefined,
  Numero: undefined,
  Complemento: undefined,
  ComplementoNumero: undefined,
});

export default function reduce(state = initialState, action = {}) {
  let payload = action.payload || {};
  switch (action.type) {
    case types.ADDRESS_SET:
      return state.merge(payload);
    case types.ADDRESS_RESET:
      return state.merge(initialState);
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
}
